import CustomRouter from './CustomRouter'

export default CustomRouter
